const config = {
  API_ENDPOINT: " https://crmapi.audiojob.fr/api/v1"
  // API_ENDPOINT: "http://localhost:8080/api/v1"
}

export default config
